import { render, staticRenderFns } from "./VueSimpleRangeSlider.vue?vue&type=template&id=06329002&scoped=true&"
import script from "./VueSimpleRangeSlider.vue?vue&type=script&lang=ts&"
export * from "./VueSimpleRangeSlider.vue?vue&type=script&lang=ts&"
import style0 from "./VueSimpleRangeSlider.vue?vue&type=style&index=0&id=06329002&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06329002",
  null
  
)

export default component.exports